import React from 'react';
import Spinner from '@amzn/awsui-components-core/spinner';
import styles from 'src/components/star-grid/components/styles/StarGridLoading.module.scss';

/**
 * The one loading state for a whole StarGrid screen: centred, full height, theme background.
 *
 * Every screen used to roll its own — a small `Box padding="l"` spinner at the top while one resource
 * resolved, then the child view's own centred spinner once it mounted. The spinner visibly jumped from
 * the top of the page to the middle of it, and the page arrived in two steps. One component means one
 * position.
 */
export const StarGridLoading: React.FC<{ readonly label: string }> = ({ label }) => (
  <div className={styles.loading} role="status" aria-live="polite">
    <Spinner size="large" />
    <span>{label}</span>
  </div>
);

export default StarGridLoading;
